import { render, staticRenderFns } from "./ExchangePopup.vue?vue&type=template&id=33bc1693&scoped=true"
import script from "./ExchangePopup.vue?vue&type=script&lang=ts"
export * from "./ExchangePopup.vue?vue&type=script&lang=ts"
import style0 from "./ExchangePopup.vue?vue&type=style&index=0&id=33bc1693&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc1693",
  null
  
)

export default component.exports